/*
 * This generates uniform user cards. 
 * For use in search results and carousels
 * 
 */
let React = require("react");

export class CreatorCard extends React.Component {
    constructor(props) {
        super(props);
    }

    renderUserIcons(user) {
        let icons = [],
            userIcons = user.icons.slice(0, 6);

        userIcons.forEach(icon => {
            icons.push(
                <li
                    key={"creatorCard.creator.icon." + icon.id}
                    className="card-icon-item"
                >
                    <a
                        href={`${user.permalink}/uploads?i=${icon.id}`}
                        className="card-icon-link"
                    >
                        <img src={icon.preview_url_84} alt={icon.term} />
                    </a>
                </li>
            );
        });

        // Pad out the icon list with dummies
        let iconDummies = 6 - icons.length;
        if (iconDummies > 0) {
            let i = 1;
            while (i <= iconDummies) {
                icons.push(
                    <li
                        key={"creatorCard.creator.icon.dummy." + i}
                        className="card-icon-item icon-dummy"
                    />
                );
                i++;
            }
        }
        return icons;
    }

    render() {
        let user = this.props.user,
            icons = this.renderUserIcons(user);

        return (
            <div
                key={"creatorCard.creator." + user.id}
                className="card-item padding-m"
            >
                <div className="creator-card-avatar">
                    <a href={user.permalink}>
                        <img
                            src={user.avatar}
                            width="42"
                            height="42"
                            alt="User avatar"
                        />
                    </a>
                </div>
                <h1 className="font-medium margin-m">
                    <a className="card-link" href={user.permalink}>
                        {user.name}
                    </a>
                </h1>

                <ul className="card-icon-list">{this.renderUserIcons(user)}</ul>

                <div className="margin-t-s font-small">
                    <a className="card-link" href={user.permalink}>
                        View
                    </a>
                </div>
            </div>
        );
    }
}
